import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { mapToDateTimeRange } from '@modules/common/utils';
import { QuantifyState } from '@modules/quantify/store/types';
import { getDurationForCompareByPreviousTimePeriod } from '@modules/quantify/utils';

interface GetDateTimeRangeFromCompareQueryOptions {
  query: QuantifyState['query'];
  isFieldA: boolean;
}

export const getDateTimeRangeFromCompareQuery = ({
  query,
  isFieldA,
}: GetDateTimeRangeFromCompareQueryOptions): DateTimeRange => {
  if (query.compareQuery?.previousPeriod && query.compareQuery?.timerange) {
    return query.duration;
  }

  if (isFieldA) {
    return query.duration;
  }

  if (query.compareQuery?.timerange) {
    return mapToDateTimeRange(query.compareQuery.timerange);
  }

  return (
    getDurationForCompareByPreviousTimePeriod(
      query.duration,
      query.compareQuery,
    ) ?? query.duration
  );
};
